// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"372":"b86bbf24","595":"7261e625","819":"d19b6ed4"}[chunkId] + ".css";
};